/* Atelier Studio — Evolve delivery.

   Adds two buttons to the Evolve tab:

     "Send layout to Claude"  - sends the recorded-session brief so the layout changes you made
                                in this panel get written into a new draft theme.
     "Run SEO + GEO evolve"   - asks Claude to pull Search Console, Shopify analytics and Ahrefs,
                                rewrite the store's SEO titles and descriptions, and build a new
                                draft theme with improved homepage copy.

   There is no way for a storefront button to call a live Claude session directly, so both post
   through Shopify's OWN contact form (/contact), which emails the store's contact address. A
   scheduled Claude task reads that mailbox and does the work.

   Kept separate from atelier-studio.js so delivery can change without touching the recorder. */
(function () {
  'use strict';

  var MOUNTED = 'data-evolve-send-mounted';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function notifyEmail() {
    var host = document.querySelector('[data-atelier-notify]');
    var v = host && host.getAttribute('data-atelier-notify');
    // Shopify uses this only as the reply-to; the message always goes to the store's
    // configured contact address.
    return (v && v.indexOf('@') !== -1) ? v : 'studio@' + location.hostname;
  }

  function post(marker, payload, btn, status, label, done) {
    btn.disabled = true;
    btn.textContent = 'Sending';
    status.textContent = '';

    var body =
      marker + '\n' +
      'shop: ' + location.hostname + '\n' +
      'sent: ' + new Date().toISOString() + '\n' +
      '--- payload json below, do not edit ---\n\n' + payload;

    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[email]', notifyEmail());
    fd.append('contact[name]', 'Atelier Studio');
    fd.append('contact[body]', body);

    fetch('/contact', { method: 'POST', body: fd })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        btn.textContent = 'Sent';
        status.textContent = done;
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        status.textContent =
          'Could not send (' + err.message + '). Copy the brief above and paste it to Claude instead.';
      });
  }

  function mount(body) {
    var ta = body.querySelector('.ast-brief');
    var row = body.querySelector('.ast-row');
    if (!ta || !row || row.hasAttribute(MOUNTED)) return;
    row.setAttribute(MOUNTED, '1');

    var status = el('p', 'ast-fine');
    ta.parentNode.insertBefore(status, ta.nextSibling);

    var layoutLabel = 'Send layout to Claude';
    var layout = el('button', 'ast-btn', layoutLabel);
    layout.setAttribute('data-evolve-send', 'layout');
    row.insertBefore(layout, row.firstChild);

    var seoLabel = 'Run SEO + GEO evolve';
    var seo = el('button', 'ast-btn ast-btn--ghost', seoLabel);
    seo.setAttribute('data-evolve-send', 'seo');
    row.insertBefore(seo, layout.nextSibling);

    layout.addEventListener('click', function (e) {
      e.stopPropagation();
      post(
        'ATELIER EVOLVE REQUEST',
        ta.value,
        layout,
        status,
        layoutLabel,
        'Layout brief emailed. The scheduled task builds a NEW draft theme from it and emails you ' +
        'the preview link. Your live theme is never touched.'
      );
    });

    seo.addEventListener('click', function (e) {
      e.stopPropagation();
      // The SEO run does its own research; the panel only supplies context about what the
      // operator is currently looking at.
      var context = JSON.stringify({
        requested: 'seo-geo-evolve',
        shop: location.host,
        path: location.pathname,
        sectionsOnPage: Array.prototype.map.call(
          document.querySelectorAll('main [id^="shopify-section-"]'),
          function (n) { return n.id.replace('shopify-section-', ''); }
        )
      }, null, 2);

      post(
        'ATELIER SEO EVOLVE REQUEST',
        context,
        seo,
        status,
        seoLabel,
        'SEO run requested. Claude will pull Search Console, Shopify analytics and Ahrefs, rewrite ' +
        'your collection titles and descriptions, build a NEW draft theme with improved homepage ' +
        'copy, and email you both. Nothing goes live without you publishing it.'
      );
    });
  }

  function watch() {
    var seen = null;
    var io = new MutationObserver(function () {
      var body = document.querySelector('.ast-panel .ast-body');
      if (!body) { seen = null; return; }
      if (body === seen && body.querySelector('[data-evolve-send]')) return;
      seen = body;
      mount(body);
    });
    io.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();